function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u7F16\u7EC4 7");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u4EFB\\u52A1\\u5B9D-\\u4F01\\u5FAE\\u6388\\u6743",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u6D3B\\u52A8\\u5DF2\\u6388\\u6743\\u4F01\\u4E1A\\u5FAE\\u4FE1-\\u914D\\u7F6E\\u6559\\u7A0B-\\u5F39\\u6846",
  transform: "translate(-586.000000, -590.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(420.000000, 280.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-8",
  transform: "translate(166.000000, 310.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-7"
}, React.createElement("circle", {
  id: "\\u692D\\u5706\\u5F62",
  fill: "#30C140",
  cx: 12,
  cy: 12,
  r: 12
}), React.createElement("g", {
  id: "weixin-2",
  transform: "translate(5.000000, 6.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M14,7.41059375 C14,5.47071875 12.0604167,3.89105209 9.87845834,3.89105209 C7.56670834,3.89105209 5.751375,5.47071875 5.751375,7.41059375 C5.751375,9.35542709 7.56670834,10.9295521 9.87845834,10.9295521 C10.3620417,10.9295521 10.8511667,10.8061771 11.3344583,10.6883438 L12.6667917,11.4186771 L12.3022083,10.2047604 C13.2743333,9.47413541 14,8.50171875 14,7.41059375 Z M8.53970834,6.80334375 C8.2985,6.80334375 8.05670834,6.56184375 8.05670834,6.31946875 C8.05670834,6.07855209 8.2985,5.83646875 8.53970834,5.83646875 C8.90545834,5.83646875 9.14754168,6.07855209 9.14754168,6.31946875 C9.14754168,6.56184375 8.90545834,6.80334375 8.53970834,6.80334375 Z M11.2110833,6.80334375 C10.9695833,6.80334375 10.728375,6.56184375 10.728375,6.31946875 C10.728375,6.07855209 10.9695833,5.83646875 11.2110833,5.83646875 C11.57625,5.83646875 11.8183333,6.07855209 11.8183333,6.31946875 C11.8183333,6.56184375 11.5704167,6.80334375 11.2110833,6.80334375 Z",
  id: "\\u5F62\\u72B6"
}), React.createElement("path", {
  d: "M9.478,3.46230209 C9.63695834,3.46230209 9.7965,3.47338543 9.95516666,3.48971875 C9.52758332,1.49180209 7.39316666,0.01071875 4.95570832,0.01071875 C2.23358334,0.01071875 0,1.86542709 0,4.22501041 C0,5.58621875 0.741125,6.70534375 1.98129166,7.57276041 L1.4875,9.06492709 L3.22145834,8.19284375 C3.84154168,8.31330209 4.340875,8.43988541 4.95570834,8.43988541 C5.109125,8.43988541 5.26341668,8.43434375 5.417125,8.41859375 C5.31825,8.08871875 5.26341666,7.73842709 5.26341666,7.38113541 C5.263125,5.21842709 7.12395834,3.46230209 9.478,3.46230209 Z M6.81041666,2.11771875 C7.18345832,2.11771875 7.43020832,2.36476041 7.43020832,2.73809375 C7.43020832,3.11084375 7.18316666,3.35788541 6.81041666,3.35788541 C6.43708332,3.35788541 6.06433332,3.11084375 6.06433332,2.73809375 C6.069875,2.36446875 6.44233334,2.11771875 6.81041666,2.11771875 Z M3.34220834,3.35730209 C2.968875,3.35730209 2.596125,3.11055209 2.596125,2.73751043 C2.596125,2.36417709 2.96916666,2.11742709 3.34220834,2.11742709 C3.71583334,2.11742709 3.962875,2.36446875 3.962875,2.73751043 C3.96258334,3.10530209 3.71583334,3.35730209 3.34220834,3.35730209 Z",
  id: "\\u5F62\\u72B6"
})))))));

var SvgWX = function SvgWX(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wX.b31592a7.svg";
export { ForwardRef as ReactComponent };